module.exports = __webpack_public_path__ + "static/media/brand-linkedin.31194f4d.svg";